import { Component, OnInit } from '@angular/core';
import { JobService } from '../../service/job.service';

@Component({
  selector: 'app-job-trace',
  templateUrl: './job-trace.component.html',
  styleUrls: ['./job-trace.component.less']
})
export class JobTraceComponent implements OnInit {
  job: any = null;
  traces: any[] = null;

  constructor(private jobService: JobService) { }

  async ngOnInit() {
    if (this.job == null) {
      return;
    }
    // 查找历史轨迹
    const oldTraces = await this.jobService.getJobTraces(this.job.jno);
    if ( oldTraces != null){
      for (const trace of oldTraces) {
        if (trace.attachmentFlag === '1'){
          for (const attachment of trace.attachments){
            attachment.url = 'attachmentServer' + attachment.url;
          }
        }
      }
    }
    this.traces = oldTraces;
  }

}
